import React, { useEffect, useState } from 'react'
import { XMarkIcon } from '@heroicons/react/24/outline';

function Popup({action}) {

const [list, setList] = useState([]);
const [open, setOpen] = useState(false);
const [notify, setNotify] = useState(false);



const toggle = async (v) => {
  if(open){
    setOpen(false);
  }else{
    setOpen(true);
    setNotify(v.id);
  }
};



const pullUpdate = async () => {

}




useEffect(() => {
 pullUpdate();
},[]);



  return (
        <div className=' flex flex-row  w-full h-full overflow-hidden'>
    
           <div className=' inset-0 z-50 bg-white w-full  h-full'>
              <div className='flex flex-row justify-between '>
               <h5 className='flex-1 ml-5'>  Request </h5>
               <XMarkIcon className='right-0 ml-auto self-end mr-2 cursor-pointer' onClick={action}  width={30} height={30}/>
              </div>
              <div className='pt-2'>
                {list.map((v,i) => <div className='p-5 m-5 bg-white w-auto h-auto rounded-xl shadow-sm border border-border-light'>From: {v.accesscode} <br/> <br/> <button className='p-1' onClick={(e) => toggle(v)}>{v.status == "seen" ? "seen" : "view"} </button> {open && notify == v.id  ? v.msg : null} </div>)}
              </div>
          </div>
         </div>
   
  
  )
}

export default Popup
